var _rect, _rect2, _polygon, _polygon2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    id: "risk-assessment",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 322.709,
    height: 432.428,
    x: 34.966,
    y: 59.572,
    fill: "#FFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 303.015,
    height: 412.735,
    x: 54.661,
    y: 59.572,
    fill: "#B5BFC1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "396.832 93.291 396.832 452.431 74.126 452.431 74.126 20 323.541 20 323.541 93.291"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EF5F36",
    points: "396.832 93.291 323.541 93.291 323.541 20"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26.569,
    height: 60.324,
    x: 138.838,
    y: 193.285,
    fill: "#FFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 36.569,
    height: 84.389,
    x: 190.853,
    y: 174.22,
    fill: "#F4C551"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 26.569,
    height: 88.454,
    x: 254.482,
    y: 165.155,
    fill: "#FFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 36.569,
    height: 112.519,
    x: 307.305,
    y: 146.09,
    fill: "#F4C551"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 196.309,
    height: 30.005,
    x: 104.927,
    y: 68.205,
    fill: "#46CBD6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF5F36",
    d: "M132.434 296.178v17.506h-17.506v-17.506H132.434M142.434 286.178h-37.506v37.506h37.506V286.178L142.434 286.178zM132.434 346.744v17.506h-17.506v-17.506H132.434M142.434 336.744h-37.506v37.506h37.506V336.744L142.434 336.744z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 37.506,
    height: 37.507,
    x: 104.927,
    y: 387.31,
    fill: "#EF5F36"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "428.641 446.273 428.641 464.332 436.251 464.332 453.656 464.332 461.268 464.332 461.268 446.273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4C551",
    d: "M428.641,424.006v22.268h32.627v-22.545C447.148,423.532,428.641,423.386,428.641,424.006z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.627,
    height: 238.037,
    x: 428.641,
    y: 185.545,
    fill: "#46CBD6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.405,
    height: 22.731,
    x: 436.251,
    y: 464.332,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "428.641 169.314 428.641 185.545 461.268 185.545 461.268 169.314 444.954 130.432"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "352.676 487 39.966 487 39.966 64.572 54.661 64.572 54.661 54.572 29.966 54.572 29.966 497 362.676 497 362.676 472.307 352.676 472.307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.611,15H69.126v442.431h332.706V91.22L325.611,15z M328.541,32.071l56.219,56.22h-56.219V32.071z M79.126,447.431V25 h239.415v73.291h73.291v349.14H79.126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.407 188.285h-36.569v70.325h36.569V188.285zM160.407 248.609h-16.569v-50.325h16.569V248.609zM286.052 160.155h-36.569v98.454h36.569V160.155zM276.052 248.609h-16.569v-78.454h16.569V248.609z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208.484,
    height: 10,
    x: 157.534,
    y: 311.43
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208.484,
    height: 10,
    x: 157.534,
    y: 290.929
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208.484,
    height: 10,
    x: 157.534,
    y: 361.996
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208.484,
    height: 10,
    x: 157.534,
    y: 341.494
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208.484,
    height: 10,
    x: 157.534,
    y: 412.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208.484,
    height: 10,
    x: 157.534,
    y: 392.061
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.671,
    height: 10,
    x: 104.927,
    y: 125.159
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.145,
    height: 10,
    x: 104.927,
    y: 143.483
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.033,344.699v74.209c-1.637-0.031-3.602-0.065-5.766-0.102v-17.068v-5V284.888v-99.342v-5v-12.238l-21.313-50.799 l-21.313,50.799v12.238v5v99.342v111.851v5v44.535v5v18.059h7.61v22.731h27.405v-22.731h7.611v-18.059v-5v-17.465 c6.199,0.104,10.657,0.195,10.662,0.195l5.104,0.106v-84.411H472.033z M456.268,459.332h-2.611h-17.405h-2.61v-8.059h22.627 V459.332z M448.656,469.332v12.731h-7.405v-12.731H448.656z M433.641,441.273v-12.652c3.506-0.073,10.129-0.104,22.627,0.043 v12.609H433.641z M433.641,418.601v-11.862h22.627v11.923C444.965,418.518,438.014,418.483,433.641,418.601z M433.641,170.32 l11.313-26.964l11.313,26.964v10.225h-22.627V170.32z M433.641,284.888v-94.342h22.627v94.342v111.851h-22.627V284.888z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskAssessment);
export default __webpack_public_path__ + "static/media/risk-assessment.cc7e6243780e89408569e9cad607a8a5.svg";
export { ForwardRef as ReactComponent };